import { compassBordeaux, graphPalette, graphPaletteV2 } from "../../../styles";
import { MilestoneKey } from "./models";

export const STAGES = [
  "m1_status",
  "m2_status",
  "m3_status",
  "m4_status",
] as const;

export const LABEL: Record<MilestoneKey, string> = {
  m1_status: "M1",
  m2_status: "M2",
  m3_status: "M3",
  m4_status: "M4",
  finished: "Completed",
  corporate_issue: "Corporate Issue",
};

export const nodeColors: Record<string, string> = {
  Engagements: "#929395",
  [LABEL.corporate_issue]: graphPalette[2],
  [LABEL.finished]: "#DDF6E8",
  Discontinued: compassBordeaux,
  [LABEL.m1_status]: graphPaletteV2[0],
  [LABEL.m2_status]: graphPaletteV2[1],
  [LABEL.m3_status]: graphPaletteV2[2],
  [LABEL.m4_status]: graphPaletteV2[3],
};
